export const primary100 = '#003F73';
export const primary200 = '#DA3347';
export const primary300 = '#E46675';
export const primary400 = '#EC99A3';
export const primary500 = '#F6CCD1';

export const secondary100 = '#F9602C';
export const secondary200 = '#FA8056';
export const secondary300 = '#FCA080';
export const secondary400 = '#FCBFAB';
export const secondary500 = '#FEDFD5';

export const neutral100 = '#0F172A';
export const neutral200 = '#1E293B';
export const neutral300 = '#334155';
export const neutral400 = '#475569';
export const neutral500 = '#64748B';
export const neutral600 = '#94A3B8';
export const neutral700 = '#CBD5E1';
export const neutral800 = '#E2E8F0';
export const neutral900 = '#F1F5F9';
export const neutral1000 = '#F8FAFC';

export const success100 = '#0C9785';
export const success200 = '#3DAC9E';
export const success300 = '#6DC1B6';
export const success400 = '#9ED5CE';
export const success500 = '#CEEAE6';

export const warning100 = '#DED717';
export const warning200 = '#E5DF45';
export const warning300 = '#ECE774';
export const warning400 = '#F1EFA2';
export const warning500 = '#F8F7D1';

export const error100 = '#9D1111';
export const error200 = '#B14141';
export const error300 = '#C47070';
export const error400 = '#D8A0A0';
export const error500 = '#EBCFCF';

export const other1 = '#F7FFF1';
export const other2 = '#24D4BD';
export const other3 = '#2480D1';
export const other4 = '#003F73';
export const other5 = '#66218F';
export const other6 = '#FFFFFF';
export const other7 = '#00D118';

export const others38 = '#1078D9';
export const others39 = '#F28607';
export const others40 = '#38B7C9';
export const others41 = '#8349A1';
export const others43 = '#835569';
export const others44 = '#3E555E';
export const others45 = '#545574';
export const others46 = '#532514';
export const others47 = '#300338';
export const others48 = '#FA8056';
export const others49 = '#007EBB';
export const others50 = '#2C0D0C';
export const others51 = '#8E9D61';
export const others52 = '#D9E1C1';
export const others53 = '#81A9B8';
export const others54 = '#D0E5ED';
export const others42 = '#161616';
export const others55 = "#D9D9D9";
export const completed = '#00632E';
export const inProgress = '#F68821';
export const notStarted = '#000';

export const others56 = '#F2EAE0';
export const others57 = '#BF81A3';
export const others58 = '#EDE0E7';
export const others59 = '#7CEF00';
export const others60 = '#F1FFE3';
export const others61 = '#8EC0E8';
export const others62 = '#DFE4E8';
export const others63 = '#A5A5FB';
export const others64 = '#DBDBF5';
export const others65 = '#F894CA';
export const others67 = '#7CE858';
export const others68 = '#E4F0E0';
export const others69 = '#FFCB59';
export const others70 = '#EEE5D1';
export const others71 = '#D9CA00';
export const others72 = '#EAE8CD';
export const others73 = '#67B6FF';
export const others74 = '#DEEFFF';
export const others75 = '#C0C094';
export const others76 = '#FCFCD6';
export const others77 = '#27ED72';
export const others78 = '#E2FFED';
export const others79 = '#9CBBFF';
export const others80 = '#E6EEFF';
export const others81 = '#B091FF';
export const others82 = '#F2EDFF';
export const others83 = '#0076B4';
export const appBackground = "#EAF5FF"
export const others84 = '#1967D2';
export const others85 = '#DDECFD';
export const others86 = '#161616';
export const blueRibbon = '#0f62fe';
export const grayBg = "#F4F4F4";
export const feedbackColor = "#0F62FE";
export const zircon= "#F4F9FF";
export const dustyGray = "#999999";
export const wildSand = "#F6F6F6";
export const roman = "#DA5257";
export const chablis = "#FFF3F3";
export const observatory = "#008D74";
export const aeroBlue = "#B3FFF1";
export const success = '#00D382';
export const spindle = '#C3DAF0';
export const primary = '#F68821';
export const nameCardBackground = '#FFEBD9';
export const gray6 = '#666666';
export const secondary = "#C02026";
export const primeB50 = '#F2672A'